<script>
import { isNumber } from 'lodash'

import Spacer from 'linna/components/Spacer'

import StyledLinkButton from '@/components/snippets/StyledLinkButton'

import shortcuts from '@/config/shortcuts'

export default {
  name: 'GameNavigationTop',

  components: {
    Spacer,
    StyledLinkButton
  },

  data () {
    return {

      tabRoutes: [
        'radios',
        'decoder',
        'files',
        'map',
        'notebook',
        'inventory'
      ],

      shortcuts: {
        radios: shortcuts.radios,
        decoder: shortcuts.decoder,
        files: shortcuts.files,
        inventory: shortcuts.inventory,
        map: shortcuts.map,
        notebook: shortcuts.notebook
      }
    }
  },

  computed: {

    currentTabIndex () {
      const i = this.tabRoutes.indexOf(this.$route.name)
      return i > -1 ? i : null
    }

  },

  methods: {

    navigateToTab (i) {
      if (this.tabRoutes[i]) {
        this.$router.push({
          name: this.tabRoutes[i]
        })
      }
    },

    onNavigateLeft () {
      if (isNumber(this.currentTabIndex)) {
        this.navigateToTab(this.currentTabIndex - 1)
      }
    },

    onNavigateRight () {
      if (isNumber(this.currentTabIndex)) {
        this.navigateToTab(this.currentTabIndex + 1)
      }
    }

  }

}
</script>

<template>
  <!-- https://github.com/aaronkirkham/vue-gamepad/blob/master/lib/button-mapping.js#L1 -->
  <div
    v-gamepad:shoulder-left="onNavigateLeft"
    v-gamepad:trigger-left="onNavigateLeft"
    v-gamepad:shoulder-right="onNavigateRight"
    v-gamepad:trigger-right="onNavigateRight"
    class="c-game-navigation-top"
  >
    <div class="c-game-navigation-top-content">

      <!-- FIXME: make StyledButton support shortkeys natively -->

      <styled-link-button
        :shortcut="shortcuts.radios"
        :to="{ name: 'radios' }"
        class="c-game-navigation-top-item"
      >
        <span class="c-game-navigation-top-highlight">C</span>OMM
      </styled-link-button>

      <spacer />

      <styled-link-button
        :shortcut="shortcuts.decoder"
        :to="{ name: 'decoder' }"
        class="c-game-navigation-top-item"
      >
        <span class="c-game-navigation-top-highlight">D</span>CDR
      </styled-link-button>

      <spacer />

      <styled-link-button
        :shortcut="shortcuts.files"
        :to="{ name: 'files' }"
        class="c-game-navigation-top-item"
      >
        <span class="c-game-navigation-top-highlight">F</span>ILE
      </styled-link-button>

      <spacer />

      <styled-link-button
        :shortcut="shortcuts.map"
        :to="{ name: 'map' }"
        class="c-game-navigation-top-item"
      >
        <span class="c-game-navigation-top-highlight">M</span>AP
      </styled-link-button>

      <spacer />

      <styled-link-button
        :shortcut="shortcuts.notebook"
        :to="{ name: 'notebook' }"
        class="c-game-navigation-top-item"
      >
        <span class="c-game-navigation-top-highlight">N</span>OTE
      </styled-link-button>

      <spacer />

      <styled-link-button
        :shortcut="shortcuts.inventory"
        :to="{ name: 'inventory' }"
        class="c-game-navigation-top-item"
      >
        <span class="c-game-navigation-top-highlight">I</span>TMS
      </styled-link-button>

    </div>
  </div>
</template>

<style lang="scss">

.c-game-navigation-top-content {
  @include flex;
}

.c-game-navigation-top-item {
  @include pad;

  &.router-link-exact-active {
    box-shadow: inset 0 0 0 0.1rem $green;

    .c-game-navigation-top-highlight {
      background-color: $green;
    }

  }

}

.c-game-navigation-top-highlight {
  color: $dark;
  background-color: $default-text-color;
}

</style>
